module.exports = __webpack_public_path__ + "static/Rosewater5-be4d8b25ce3d3f515d7090fa09f0fbe6.png";